import React from "react";
import useNotifier from "../../hooks/useNotifier";

const MessageToaster = () => {
  useNotifier();
  return <></>;
};
export default MessageToaster;
